import { ref, onUnmounted } from 'vue';

export function useAudioPlayer() {
  const audio = new Audio();
  const isPlaying = ref(false);
  const currentSrc = ref<string | null>(null);

  const play = (src?: string) => {
    // 如果有新的src且与当前播放的不同，先暂停当前音频并重置播放进度
    if (src && src !== currentSrc.value) {
      pause(); // 暂停当前播放
      audio.currentTime = 0; // 重置播放进度
      audio.src = src;
      currentSrc.value = src;
    }

    // 播放音频
    audio.play().catch((error) => {
      console.error('Error playing audio:', error);
    });
    isPlaying.value = true;
  };

  const pause = () => {
    if (audio.paused) return; // 防止已经暂停时重复调用
    audio.pause();
    isPlaying.value = false;
  };

  const toggle = (src?: string) => {
    if (isPlaying.value && src === currentSrc.value) {
      pause();
    } else {
      play(src);
    }
  };

  const setVolume = (volume: number) => {
    if (volume >= 0 && volume <= 1) {
      audio.volume = volume;
    } else {
      console.warn('Volume should be between 0.0 and 1.0');
    }
  };
  const setPlaybackRate = (rate: number) => {
    if (rate >= 0.25 && rate <= 2.0) {
      audio.playbackRate = rate;
    } else {
      console.warn('Playback rate should be between 0.25 and 2.0');
    }
  };
  // 统一管理事件处理函数
  const handlers = {
    play: () => (isPlaying.value = true),
    pause: () => (isPlaying.value = false),
    ended: () => (isPlaying.value = false),
  };

  // 批量添加事件监听
  Object.entries(handlers).forEach(([event, handler]) => {
    audio.addEventListener(event, handler);
  });

  onUnmounted(() => {
    Object.entries(handlers).forEach(([event, handler]) => {
      audio.removeEventListener(event, handler);
    });
    audio.pause();
    audio.currentTime = 0;
  });

  return {
    isPlaying,
    play,
    pause,
    toggle,
    setVolume,
    currentSrc,
    setPlaybackRate,
  };
}
